// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};



//////////////////
// WEBPACK FOOTER
// ../~/babel-polyfill/~/core-js/modules/_to-index.js
// module id = 474
// module chunks = 0